import { useEffect } from "react";
import { useRouter } from "next/router";
import { useUser } from "@auth0/nextjs-auth0";
// import { useLazyQuery } from "@apollo/client";
import { useSetRecoilState } from "recoil";

// import { GET_MEMBER } from "../../lib/graphql/users.queries";
import { apiLoginUser } from "../../lib/api/user";
import { userState } from "../../atoms/user";
import { setLocalStorage, setSessionStorage } from "../../helpers/storage";

import toast, { Toaster } from "react-hot-toast";
import Loading from "../Shared/Loading";

const LOGOUT_DELAY = 4000;

function Auth() {
  const router = useRouter();
  const { user: auth } = useUser();
  const setUser = useSetRecoilState(userState);
  // const [getUser, { data: clientUser }] = useLazyQuery(GET_MEMBER, {
  //   fetchPolicy: "network-only",
  //   nextFetchPolicy: "network-only",
  // });

  // the Auth0 session is still valid here, so log out or the home page
  // bounces straight back to /login
  const failLogin = () => {
    toast.error(
      "We couldn't find an account for your login. Please contact your administrator.",
      { duration: LOGOUT_DELAY },
    );
    setTimeout(() => router.push("/api/auth/logout"), LOGOUT_DELAY);
  };

  useEffect(() => {
    // console.log(auth);
    const fetchData = async () => {
      let result;
      try {
        const response = await fetch(`/api/profile/${auth.sub}`);
        result = await response.json();
      } catch (error) {
        console.log("error fetching profile", error);
      }
      if (!result?.user_metadata) {
        failLogin();
      } else {
        // get the user and set it to user state before handling the push
        let email = result.email;
        let clientId = result.user_metadata.clientId;
        // if (result.email === "ajthompson@clouddrivensolutions.com") {
        //   // email = "tjohare@tarrantcountytx.gov";
        //   email = "kmbuchanan@tarrantcountytx.gov";
        //   clientId = "tarrantcountytx";
        // }
        const userResult = await apiLoginUser({
          // email: result.email,
          email,
          clientId,
        });
        if (!userResult) {
          failLogin();
        } else {
          setUser(userResult);
          setSessionStorage("user", userResult);
          setLocalStorage("cds-user", userResult);
          if (userResult.role === "board") {
            router.push(`/board/${userResult.clientId}/agendas`);
          } else if (userResult.role === "viewer") {
            router.push(`/viewer/${userResult.clientId}/agendas`);
          } else {
            router.push(`/${userResult.clientId}/dashboard`);
          }
        }
        // getUser({
        //   variables: {
        //     clientId: result.user_metadata.clientId,
        //     email: result.email,
        //   },
        // });
      }
    };
    if (auth) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  // useEffect(() => {
  //   if (clientUser) {
  //     // console.log(clientUser.clientMember);
  //     // now go to dashboard
  //     setUser(clientUser.clientMember);
  //     // set session storage
  //     setSessionStorage("user", clientUser.clientMember);
  //     router.push(
  //       `/[client]/dashboard`,
  //       `${clientUser.clientMember.clientId}/dashboard`
  //     );
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [clientUser]);

  return (
    <div>
      <Loading />
      <Toaster />
    </div>
  );
}

export default Auth;
